import React from "react";

export interface PulsingIndicatorProps {
  color?: "green" | "red" | "blue" | "yellow" | "orange" | "purple" | "gray";
  size?: "sm" | "md" | "lg";
  className?: string;
}

const colorMap = {
  green: {
    ping: "bg-green-400",
    solid: "bg-green-500",
  },
  red: {
    ping: "bg-red-400",
    solid: "bg-red-500",
  },
  blue: {
    ping: "bg-blue-400",
    solid: "bg-blue-500",
  },
  yellow: {
    ping: "bg-yellow-400",
    solid: "bg-yellow-500",
  },
  orange: {
    ping: "bg-orange-400",
    solid: "bg-orange-500",
  },
  purple: {
    ping: "bg-purple-400",
    solid: "bg-purple-500",
  },
  gray: {
    ping: "bg-gray-400",
    solid: "bg-gray-500",
  },
};

const sizeMap = {
  sm: "h-1.5 w-1.5",
  md: "h-2 w-2",
  lg: "h-3 w-3",
};

export const PulsingIndicator: React.FC<PulsingIndicatorProps> = ({
  color = "green",
  size = "md",
  className = "",
}) => {
  const colors = colorMap[color];
  const sizeClasses = sizeMap[size];

  return (
    <span className={`relative flex ${sizeClasses} ${className}`}>
      <span
        className={`animate-ping absolute inline-flex h-full w-full rounded-full ${colors.ping} opacity-75`}
      />
      <span
        className={`relative inline-flex rounded-full ${sizeClasses} ${colors.solid}`}
      />
    </span>
  );
};
